import { createSlice, isAnyOf } from '@reduxjs/toolkit';
import { getPatientData } from './actions';
import { PatientResponseDto, ValueOf } from 'types/types';
import { DataStatus } from 'types/enums';

type State = {
  status: ValueOf<typeof DataStatus>;
  data: null | PatientResponseDto;
};

const initialState: State = {
  data: null,
  status: DataStatus.IDLE,
};

const { reducer, actions } = createSlice({
  initialState,
  name: 'patient',
  reducers: {},
  extraReducers(builder) {
    builder.addCase(getPatientData.fulfilled, (state, { payload }) => {
      state.status = DataStatus.SUCCEEDED;
      state.data = payload;
    });
    builder.addCase(getPatientData.pending, (state) => {
      state.status = DataStatus.LOADING;
    });
    builder.addCase(getPatientData.rejected, (state) => {
      state.status = DataStatus.FAILED;
    });
    builder.addMatcher(isAnyOf(getPatientData.pending, getPatientData.rejected), (state) => {
      state.data = null;
    });
  },
});

export { actions, reducer };
